import { GET_LIST_MENU_HAK_AKSES, GET_LIST_PEGAWAI_ROLE } from "shared/constants/ActionTypes";

const INIT_STATE = {
    list: {
        menus: null,
        results: []
    }
};

const pengaturanReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PEGAWAI_ROLE: {
            return {
                ...state,
                list: action.payload
            }
        }
        case GET_LIST_MENU_HAK_AKSES: {
            return {
                ...state,
                list: {
                    ...state.list,
                    menus: action.payload,
                }
            }
        }
        default:
            return state;
    }
};
export default pengaturanReducer;
